// SEO meta (title + description) per page, bilingual.
const kw = {
  de: 'Metakaolin, Metakaolin kaufen, puzzolanisches Additiv, Beton Zusatzstoff, Zement, Mörtel, Kalk, Puzzolan, Chapelle-Test, BET, Newchem GmbH, Dauerhaftigkeit Beton, CO2 Reduktion Zement',
  en: 'metakaolin, buy metakaolin, pozzolanic additive, concrete admixture, cement, mortar, lime, pozzolan, Chapelle test, BET surface, Newchem GmbH, concrete durability, low CO2 cement',
};

export const SEO_KEYWORDS = kw;

export const seoData = {
  home: {
    de: {
      title: 'Metakaolin – das puzzolanische Additiv für Beton & Mörtel',
      description:
        'Alles über Metakaolin: puzzolanische Reaktion, Qualitätskriterien, Eigenschaften, Anwendungen und Datenblätter. Die Wissensplattform der Newchem GmbH aus Österreich.',
    },
    en: {
      title: 'Metakaolin – the pozzolanic additive for concrete & mortar',
      description:
        'Everything about metakaolin: pozzolanic reaction, quality criteria, features, applications and data sheets. The knowledge platform by Newchem GmbH, Austria.',
    },
  },
  quality: {
    de: { title: 'Qualitätskriterien von Metakaolin', description: 'Kalkbindevermögen (Chapelle-Test), Reaktivität & spezifische Oberfläche (BET), mechanische Eigenschaften und Farbe – was hochwertiges Metakaolin ausmacht.' },
    en: { title: 'Quality criteria of metakaolin', description: 'Lime-binding capacity (Chapelle test), reactivity & specific surface (BET), mechanical properties and colour – what defines high-quality metakaolin.' },
  },
  features: {
    de: { title: 'Besondere Eigenschaften von Metakaolin', description: 'Die 13 besonderen Eigenschaften von Metakaolin: Dauerhaftigkeit, AKR-Reduktion, Sulfatbeständigkeit, Chloridmigration, hellere Farbe, CO2-Reduktion und mehr.' },
    en: { title: 'Specific features of metakaolin', description: 'The 13 specific features of metakaolin: durability, ASR reduction, sulphate resistance, chloride migration, lighter colour, CO2 reduction and more.' },
  },
  reaction: {
    de: { title: 'Reaktion mit Zement & Kalk', description: 'Wie Metakaolin mit Portlandzement und Kalk reagiert: Hydratation, puzzolanische Reaktion und die Bildung zusätzlicher CSH- und Aluminatphasen.' },
    en: { title: 'Reaction with cement & lime', description: 'How metakaolin reacts with Portland cement and lime: hydration, pozzolanic reaction and the formation of additional CSH and aluminate phases.' },
  },
  applications: {
    de: { title: 'Anwendungen von Metakaolin', description: 'Metakaolin-Anwendungen: Zement, Ortbeton, Fertigteilbeton, Spritzbeton, Mörtel und Geopolymere – weltweit im Einsatz.' },
    en: { title: 'Applications of metakaolin', description: 'Metakaolin applications: cement, cast-in-place concrete, precast, shotcrete, mortars and geopolymers – used around the globe.' },
  },
  downloads: {
    de: { title: 'Downloads – Datenblätter, Chapelle- & BET-Werte', description: 'Technische Datenblätter je Metakaolin-Qualität mit Chapelle-Wert, BET-Oberfläche, SiO2/Al2O3, Weißgrad und empfohlener Dosierung zum Download.' },
    en: { title: 'Downloads – data sheets, Chapelle & BET values', description: 'Technical data sheets per metakaolin grade with Chapelle value, BET surface, SiO2/Al2O3, whiteness and recommended dosage available for download.' },
  },
  cases: {
    de: { title: 'Fallstudien – Metakaolin in der Praxis', description: 'Ausgewählte Praxisbeispiele für den Einsatz von Metakaolin in Fassaden, maritimer Infrastruktur, Denkmalpflege und Schwimmbädern.' },
    en: { title: 'Case studies – metakaolin in practice', description: 'Selected real-world examples of metakaolin in facades, marine infrastructure, heritage restoration and swimming pools.' },
  },
  links: {
    de: { title: 'Externe Links & Referenzen', description: 'Weiterführende Ressourcen zu puzzolanischen Reaktionen, Zementchemie und Metakaolin.' },
    en: { title: 'External links & references', description: 'Further resources on pozzolanic reactions, cement chemistry and metakaolin.' },
  },
  disclaimer: {
    de: { title: 'Haftungsausschluss', description: 'Rechtliche Hinweise und Haftungsausschluss der Metakaolin-Wissensplattform der Newchem GmbH.' },
    en: { title: 'Disclaimer', description: 'Legal notice and disclaimer of the metakaolin knowledge platform by Newchem GmbH.' },
  },
  impressum: {
    de: { title: 'Impressum', description: 'Impressum und Angaben gemäß §5 ECG der Newchem GmbH – Betreiberin der Metakaolin-Wissensplattform metakaolin.info.' },
    en: { title: 'Impressum', description: 'Legal notice (Impressum) of Newchem GmbH – operator of the metakaolin knowledge platform metakaolin.info.' },
  },
  datenschutz: {
    de: { title: 'Datenschutzerklärung', description: 'Datenschutzerklärung der Newchem GmbH zur Verarbeitung personenbezogener Daten auf metakaolin.info.' },
    en: { title: 'Datenschutzerklärung', description: 'Privacy policy of Newchem GmbH regarding the processing of personal data on metakaolin.info.' },
  },
  contact: {
    de: { title: 'Kontakt – Newchem GmbH', description: 'Kontaktieren Sie das Newchem-Team in Österreich für technische Beratung, Dosierung und Lieferung von Metakaolin.' },
    en: { title: 'Contact – Newchem GmbH', description: 'Contact the Newchem team in Austria for technical advice, dosage and supply of metakaolin.' },
  },
};

export const getSeo = (key, lang) => (seoData[key] && seoData[key][lang]) || seoData.home[lang];
